import semiboldFontUrl from './fonts/open-sans-v44-latin-600.ttf';

export const NOTIFICATION_PANEL_CLASS = 'dispatchNotificationPanel';
export const NOTIFICATION_SEMIBOLD_CLASS = 'notificationSemibold';

const NOTIFICATION_FONT_STYLE_ID = 'notification-semibold-font';

const registerNotificationFonts = (): void => {
  if (typeof document === 'undefined' || document.getElementById(NOTIFICATION_FONT_STYLE_ID)) {
    return;
  }

  const style = document.createElement('style');
  style.id = NOTIFICATION_FONT_STYLE_ID;
  style.textContent = `
    @font-face {
      font-family: 'Open Sans Notification';
      src: url('${semiboldFontUrl}') format('truetype');
      font-style: normal;
      font-weight: 600;
      font-display: swap;
    }

    .${NOTIFICATION_PANEL_CLASS} .${NOTIFICATION_SEMIBOLD_CLASS} {
      font-family: 'Open Sans Notification', 'Open Sans', sans-serif !important;
      font-weight: 600 !important;
    }
  `;
  document.head.appendChild(style);
};

registerNotificationFonts();
